<div class="menu_container">
  @if (currentUser) {
    <div class="profile_container">
      @if (currentUser?.imageId) {
        <image-cloud-wrapper [publicId]="currentUser?.imageId" [size]="50" [radius]="25"></image-cloud-wrapper>
      }
      <div class="profile_name_container">
        <div class="profile_name">
          {{currentUser.firstName}} {{currentUser.lastName}}
        </div>
        <div class="profile_explorer">
          {{currentUser.email}}
        </div>
        <div class="location_explorer">
          {{currentUser.locationName}}
        </div>
      </div>
    </div>
  }

  @if (locations && locations.length > 1) {
    <div class="location_container">
      <div class="location_header_container" (click)="handleShowLocations()">
        <ion-icon name="business"></ion-icon>
        <div class="locations">
          {{ 'SIDEMENU.LOCATIONS' | translate }}
        </div>
        <ion-icon name="chevron-forward-outline" [ngClass]="showLocations ? 'invisible' : 'visible'"></ion-icon>
        <ion-icon name="chevron-down-outline" [ngClass]="showLocations ? 'visible' : 'invisible'"></ion-icon>
      </div>
      <div [ngClass]="showLocations ? 'location_accordion visible' : 'location_accordion'">
        @for (location of locations; track location.locationId) {
          <div class="location_list"
               [class.selected]="selectedLocationId === location.locationId"
               [class.disabled]="switchingLocation && selectedLocationId !== location.locationId"
               (click)="handleClickLocationList(location)">
            @if (location?.imageId) {
              <image-cloud-wrapper [publicId]="location?.imageId" [size]="24" [radius]="50"></image-cloud-wrapper>
            }
            <span class="gym_name">{{location.name}}</span>
            @if (switchingLocation && selectedLocationId === location.locationId) {
              <ion-spinner name="crescent" class="location-spinner"></ion-spinner>
            }
          </div>
        }
      </div>
    </div>
  }
  <div class="menu_list_container">
    <div class="menu_list" (click)="handleClickMenuHome('/dashboard/tabs/home')" button ion-item menuClose>
      <ion-icon name="home"></ion-icon>
      <ion-label>{{ 'SIDEMENU.HOME' | translate }}</ion-label>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    <div class="menu_list" (click)="handleClickMenuList('/dashboard/tabs/reserve')" button ion-item menuClose>
      <ion-icon name="calendar-number-sharp"></ion-icon>
      <ion-label>{{ 'SIDEMENU.BOOK_SESSION' | translate }}</ion-label>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    @if (currentUser?.contactPermission?.hasResources) {
      <div class="menu_list" (click)="handleClickMenuList('/resources')" button ion-item menuClose>
        <ion-icon name="folder-open"></ion-icon>
        <ion-label>{{ 'SIDEMENU.RESOURCES' | translate }}</ion-label>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </div>
    }
    @if (currentUser?.customerId !== '0') {
      <div class="menu_list" (click)="handleClickMenuList('/payments')" button ion-item menuClose>
        <ion-icon name="card"></ion-icon>
        <ion-label>{{ 'SIDEMENU.PAYMENT_METHODS' | translate }}</ion-label>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </div>
    }
    @if (currentUser?.customerId !== '0' && transactions.length > 0) {
      <div class="menu_list" (click)="handleClickMenuList('/invoices-pastdue')" button ion-item menuClose>
        <ion-icon name="receipt"></ion-icon>
        <ion-label>{{ 'SIDEMENU.INVOICES' | translate }}</ion-label>
        <ion-badge slot="end" class="badge_menu">{{transactions.length }} </ion-badge>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </div>
    }
    <div class="menu_list" (click)="handleClickMenuList('/dashboard/tabs/profile')" button ion-item menuClose>
      <ion-icon name="person"></ion-icon>
      <ion-label>{{ 'SIDEMENU.PROFILE' | translate }}</ion-label>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    <div class="menu_list" (click)="handleClickMenuList('settings')" button ion-item menuClose>
      <ion-icon name="settings"></ion-icon>
      <ion-label>{{ 'SIDEMENU.SETTINGS' | translate }}</ion-label>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    <div class="menu_list" (click)="handleClickNotification('notifications')" button ion-item menuClose>
      <ion-icon name="notifications"></ion-icon>
      <ion-label>{{ 'SIDEMENU.NOTIFICATIONS' | translate }}</ion-label>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    <div class="menu_list" (click)="handleClickPrivacy()">
      <ion-icon name="lock-closed"></ion-icon>
      <ion-label>{{ 'SIDEMENU.PRIVACY_TERMS' | translate }}</ion-label>
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    <div class="menu_list" (click)="handleClickLogout()">
      <ion-icon name="power"></ion-icon>
      <ion-label>{{ 'SIDEMENU.LOGOUT' | translate }}</ion-label>
    </div>
  </div>
</div>